import React from "react"

const LinkedInIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69058 8.25367C6.76233 8.25367 7.63116 7.41338 7.63116 6.37683C7.63116 5.34029 6.76233 4.5 5.69058 4.5C4.61883 4.5 3.75 5.34029 3.75 6.37683C3.75 7.41338 4.61883 8.25367 5.69058 8.25367Z"
        fill="white"
      />
      <path d="M7.63108 9.17773H3.75V19.5002H7.63108V9.17773Z" fill="white" />
      <path
        d="M16.7154 9.17773C13.8046 9.17773 13.4553 10.8481 13.4553 10.8481V9.17773H9.57422V19.5002H13.4553V13.8698C13.4553 13.8698 13.4553 11.9929 15.1048 11.9929C16.075 11.9929 16.3661 12.8281 16.3661 13.8698V19.5002H20.2472V13.8698C20.2472 10.9326 18.9277 9.17773 16.7154 9.17773Z"
        fill="white"
      />
    </svg>

    // <svg
    //   width="10"
    //   height="10"
    //   viewBox="0 0 10 10"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M1.72764 2.82247C2.33014 2.82247 2.81856 2.33405 2.81856 1.73155C2.81856 1.12905 2.33014 0.640625 1.72764 0.640625C1.12514 0.640625 0.636719 1.12905 0.636719 1.73155C0.636719 2.33405 1.12514 2.82247 1.72764 2.82247Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M2.81852 3.35938H0.636719V9.35938H2.81852V3.35938Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M7.92467 3.35938C6.28831 3.35938 6.09195 4.3303 6.09195 4.3303V3.35938H3.91016V9.35938H6.09195V6.08666C6.09195 6.08666 6.09195 4.99573 7.01923 4.99573C7.56467 4.99573 7.72831 5.48117 7.72831 6.08666V9.35938H9.91011V6.08666C9.91011 4.37938 9.16831 3.35938 7.92467 3.35938Z"
    //     fill="white"
    //   />
    // </svg>
  )
}
export default LinkedInIcon
